/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-10 08:37:14
 *
 *******************************************************/
import { URL } from 'src/constants/links';

// Import icons
import intelligenceIcon from 'src/assets/images/subscription-v3/addon/intelligence-icon.png';
import autocompleteIcon from 'src/assets/images/subscription-v3/addon/autocomplete-icon.png';
// import merchandisingIcon from 'src/assets/images/subscription-v3/addon/merchandising-icon.png';
import enhanceIcon from 'src/assets/images/subscription-v3/addon/enhance-icon.png';
import aiIcon from 'src/assets/images/subscription-v3/addon/ai-icon.png';
import quickSetupIcon from 'src/assets/images/subscription-v3/addon/quick-setup-icon.png';
import compatibleIcon from 'src/assets/images/subscription-v3/addon/theme-compatible.png';
import placementIcon from 'src/assets/images/subscription-v3/addon/placement.png';
import dynamicIcon from 'src/assets/images/subscription-v3/addon/dynamic-rule.png';
import easySetupIcon from 'src/assets/images/subscription-v3/addon/easy-setup.png';
import quickIcon from 'src/assets/images/subscription-v3/addon/quick-icon.png';
import priorityIcon from 'src/assets/images/subscription-v3/addon/priority-icon.png';
import saveIcon from 'src/assets/images/subscription-v3/addon/save-icon.png';
import calenderIcon from 'src/assets/images/subscription-v3/addon/calender-icon.png';
import comparisonIcon from 'src/assets/images/subscription-v3/addon/comparison-icon.png';
import exportIcon from 'src/assets/images/subscription-v3/addon/export-icon.png';
import variantIcon from 'src/assets/images/subscription-v3/addon/variant-icon.png';
import clockIcon from 'src/assets/images/subscription-v3/addon/clock-icon.png';
import saleIcon from 'src/assets/images/subscription-v3/addon/sale-icon.png';

// Import banner review popup
import aiPowerSearchBanner from 'src/assets/images/subscription-v3/addon/ai-power-search-banner.png';
import aiPowerRecommendationBanner from 'src/assets/images/subscription-v3/addon/ai-power-recommendation-banner.png';
import visualMerchandisingBanner from 'src/assets/images/subscription-v3/addon/visual-merchandising-banner.png';
import syncFrequencyBanner from 'src/assets/images/subscription-v3/addon/sync-frequency-banner.png';
import analyticsBanner from 'src/assets/images/subscription-v3/addon/analytics-banner.png';
import variantDisplayBanner from 'src/assets/images/subscription-v3/addon/variant-display-banner.png';
// Import card image
import aiPowerSearchCard from 'src/assets/images/subscription-v3/ai-power-search.png';
import aiPowerRecommendationCard from 'src/assets/images/subscription-v3/recommendation.png';
import visualMerchandisingCard from 'src/assets/images/subscription-v3/visual-merchandising.png';
// import syncFrequencyCard from 'src/assets/images/subscription-v3/sync-frequency.png';
import analyticsCard from 'src/assets/images/subscription-v3/analytics.png';
import variantDisplayCard from 'src/assets/images/subscription-v3/variant-display.png';

// Slide addon
import SlideItem_sli_product_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_product_des.png';
import SlideItem_sli_semantic_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_semantic_des.png';
import SlideItem_sli_synonym_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_synonym_des.png';
import SlideItem_sli_suggest_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_suggest_des.png';
import SlideItem_sli_freq_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_freq_des.png';
import SlideItem_sli_related_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_related_des.png';
import SlideItem_sli_recent_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_recent_des.png';
import SlideItem_sli_extend_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_extend_des.png';
import SlideItem_sli_insight_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_insight_des.png';
import SlideItem_sli_trend_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_trend_des.png';
import SlideItem_sli_increase_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_increase_des.png';
import SlideItem_sli_optimize_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_optimize_des.png';
import SlideItem_sli_pin_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_pin_des.png';
import SlideItem_sli_boost_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_boost_des.png';
import SlideItem_sli_demote_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_demote_des.png';
import SlideItem_sli_hide_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_hide_des.png';
import SlideItem_sli_filter_des from 'src/assets/images/subscription-v3/addon/slide/item_sli_filter_des.png';

export const AI_POWERED_SEARCH_NAME = 'AI-powered-search';
export const AI_POWERED_RECOMMENDATION_NAME = 'AI-powered-recommendation';
export const VISUAL_MERCHANDISING_NAME = 'visual-merchandising';
export const VARIANT_DISPLAY_NAME = 'variant-display';
export const SYNC_FREQUENCY_NAME = 'sync-frequency';
export const ANALYTICS_ADDON_NAME = 'analytics';
export const LARGE_PRODUCT = 50000;

export const PACKAGES = [
  {
    name: 'basic',
    title: 'AdminHTML.SubscriptionV3.Packages.package01',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard01',
    addons: ['30-analytics'],
    subtext: 'AdminHTML.SubscriptionV3.Packages.BasicPackage.subtext',
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01',
      // 'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO9',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO4',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO8',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.BasicPackage.content10',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics01'
    ]
  },
  {
    name: 'essential',
    title: 'AdminHTML.SubscriptionV3.Packages.package02',
    subtext: 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard02',
    addons: ['90-analytics', 'aiPowerSearch', 'aiPowerRecommendation', 'visualMerchandising'],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO4',
      // 'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO5',
      'AdminHTML.SubscriptionV3.Packages.EssentialPackage.contentO6'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.name',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics02'
    ]
  },
  {
    name: 'professional',
    title: 'AdminHTML.SubscriptionV3.Packages.package03',
    subtext: 'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.subtext',
    advanceLabel: 'AdminHTML.SubscriptionV3.Packages.advanceTitleCard03',
    addons: [
      'aiPowerSearch',
      'aiPowerRecommendation',
      'visualMerchandising',
      'variantDisplay',
      // 'syncFrequency',
      '180-analytics'
    ],
    basicList: [
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO1',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO2',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO3',
      'AdminHTML.SubscriptionV3.Packages.ProfessionalPackage.contentO4'
    ],
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.name',
      'AdminHTML.SubscriptionV3.Addons.Analytics.analytics03'
      // 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.label'
    ]
  }
];

export const ADDONS_INFO = [
  {
    name: 'aiPowerSearch',
    addonName: 'AI-powered-search',
    image: aiPowerSearchCard,
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.description',
    price: 39,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature01.advance02'
    ]
  },
  {
    name: 'aiPowerRecommendation',
    addonName: 'AI-powered-recommendation',
    image: aiPowerRecommendationCard,
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.description',
    price: 39,
    allowTrial: true,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature02.advance02'
    ]
  },
  {
    name: 'visualMerchandising',
    addonName: 'visual-merchandising',
    image: visualMerchandisingCard,
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.description',
    price: 19,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV3.Addons.AddonFeature.feature03.advance01']
  },
  // {
  //   name: 'syncFrequency',
  //   addonName: 'sync-frequency',
  //   image: syncFrequencyCard,
  //   title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.name',
  //   description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.description',
  //   price: 19,
  //   allowTrial: false,
  //   advanceList: [
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.advance01',
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature06.advance02'
  //   ]
  // },
  {
    name: 'analytics',
    addonName: 'analytics',
    image: analyticsCard,
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.description',
    descriptionBackup: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.descriptionBackup',
    price: 19,
    value: [30, 90, 180, 365], //720
    allowTrial: false,
    advanceList: [
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance01',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance02',
      'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature05.advance03'
    ]
  },

  {
    name: 'variantDisplay',
    addonName: 'variant-display',
    image: variantDisplayCard,
    title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.name',
    description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.description',
    price: 29,
    allowTrial: true,
    advanceList: ['AdminHTML.SubscriptionV3.Addons.AddonFeature.feature04.advance01']
  }
  // {
  //   name: 'support',
  //   title: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.name',
  //   description: 'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.description',
  //   price: 0,
  //   advanceList: [
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance01',
  //     'AdminHTML.SubscriptionV3.Addons.AddonFeature.feature07.advance02'
  //   ]
  // }
];

export const PLAN_STATUS = [
  {
    status: 'trial',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Trial',
    type: 'attention'
  },
  {
    status: 'expiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_ExpiredSoon',
    type: 'attention'
  },
  {
    status: 'specialDiscount2021ExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_ExpiredSoon',
    type: 'attention'
  },
  {
    status: 'expired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  },
  {
    status: 'subscribed',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'exceededWithNotification',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'exceeded',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Exceeded',
    type: 'critical'
  },
  {
    status: 'exceededWithNotification',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Exceeded',
    type: 'critical'
  },
  {
    status: 'specialDiscountExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_DiscountExpiring',
    type: 'attention'
  },
  {
    status: 'specialDiscountExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Subscribe',
    type: 'success'
  },
  {
    status: 'oldSpecialDiscountExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  },
  {
    status: 'regularExpiredSoon',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_DiscountExpiring',
    type: 'attention'
  },
  {
    status: 'regularExpired',
    label: 'AdminHTML.SubscriptionV3.PlanStatus.status_Expired',
    type: 'critical'
  }
];

export const issuesChoices = [
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason01',
    value: 'notMeetNeed',
    tracking: 'Does not meet my needs.',
    code: '1'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason02',
    value: 'hardToUse',
    tracking: 'Feature is not performing well.',
    code: '2'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason03',
    value: 'notNeedAnymore',
    tracking: `Not needed any more.`,
    code: '3'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason04',
    value: 'expensive',
    tracking: 'Feature is not worth the cost.',
    code: '4'
  },
  {
    label: 'AdminHTML.SubscriptionV3.UnsubscribeFeedbackModal.reason05',
    value: 'others',
    tracking: 'Others',
    code: '6'
  }
];

export const ANALYTICS_ADDON = [
  {
    value: '90',
    name: 'analytics-90-days',
    price: 19,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics02'
  },
  {
    value: '180',
    name: 'analytics-180-days',
    price: 29,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics03'
  },
  {
    value: '365',
    name: 'analytics-365-days',
    price: 49,
    label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics04'
  }
  // {
  //   value: '720',
  //   name: 'analytics-720-days',
  //   price: 39,
  //   label: 'AdminHTML.SubscriptionV3.Addons.Analytics.analytics05'
  // }
];

export const REVIEW_ADDON_CONTENT = [
  {
    name: 'aiPowerSearch',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column01_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column01_Content',
        isNew: true
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column02_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column02_Content'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column03_Label',
        content: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section01_Column03_Content'
      }
    ],
    section02: [enhanceIcon, intelligenceIcon, autocompleteIcon],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Label',
    section03LabelSubtext: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Label_t',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content03'
    ],
    section03SubText: ['AdminHTML.SubscriptionV3.ReviewAddon.aiPowerSearch.section03_Content01_t'],
    section04: aiPowerSearchBanner
  },
  {
    name: 'aiPowerRecommendation',
    section01: [
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column01_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column01_Content'
      },
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column02_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column02_Content'
      },
      {
        label:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column03_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section01_Column03_Content'
      }
    ],
    section02: [aiIcon, quickSetupIcon, compatibleIcon],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.aiPowerRecommendation.section03_Content03'
    ],
    section04: aiPowerRecommendationBanner
  },
  {
    name: 'visualMerchandising',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column01_Label',
        content:
          'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section01_Column01_Content'
      }
    ],
    section02: [placementIcon, dynamicIcon, easySetupIcon],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content03',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content04',
      'AdminHTML.SubscriptionV3.ReviewAddon.visualMerchandising.section03_Content05'
    ],
    section04: visualMerchandisingBanner
  },
  {
    name: 'syncFrequency',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.syncFrequency.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.syncFrequency.section01_Column02_Label'
      }
    ],
    section02: [quickIcon, priorityIcon, saveIcon],
    section04: syncFrequencyBanner
  },
  {
    name: 'analytics',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column02_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section01_Column03_Label'
      }
    ],
    section02: [calenderIcon, comparisonIcon, exportIcon],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.analytics.section03_Content03'
    ],
    section04: analyticsBanner
  },
  {
    name: 'variantDisplay',
    section01: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section01_Column01_Label'
      },
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section01_Column02_Label'
      }
    ],
    section02: [variantIcon, clockIcon, saleIcon],
    section03Label: 'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Label',
    section03: [
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content01',
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content02',
      'AdminHTML.SubscriptionV3.ReviewAddon.variantDisplay.section03_Content03'
    ],
    section04: variantDisplayBanner
  }
];
// aiPowerSearch
// aiPowerRecommendation
// analytics
// variantDisplay
// visualMerchandising
export const REVIEW_ADDON_CONTENT_V2 = [
  {
    name: 'aiPowerSearch',
    url: URL['AddOn_Search'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.description',
    blockItems: [
      {
        label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_personalization',
        isNew: true
      },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_product', isNew: true },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_semantic' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_synonym' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_suggestion' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_synonym_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_synonym_des',
        img: SlideItem_sli_synonym_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_product_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_product_des',
        img: SlideItem_sli_product_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_semantic_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_semantic_des',
        img: SlideItem_sli_semantic_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_suggest_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerSearch.item_sli_suggest_des',
        img: SlideItem_sli_suggest_des
      }
    ]
  },
  {
    name: 'aiPowerRecommendation',
    url: URL['AddOn_Recommend'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_freq' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_related' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_recent' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_freq_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_freq_des',
        img: SlideItem_sli_freq_des
      },
      {
        title:
          'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_related_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_related_des',
        img: SlideItem_sli_related_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_recent_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.aiPowerRecommendation.item_sli_recent_des',
        img: SlideItem_sli_recent_des
      }
    ]
  },
  {
    name: 'analytics',
    url: URL['AddOn_Analytic'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_90' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_180' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_365' }
    ],
    blockItemsCol: 2,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_extend_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_extend_des',
        img: SlideItem_sli_extend_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_insight_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_insight_des',
        img: SlideItem_sli_insight_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_trend_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.analytics.item_sli_trend_des',
        img: SlideItem_sli_trend_des
      }
    ]
  },
  {
    name: 'variantDisplay',
    url: URL['AddOn_Variant'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_display' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_optimize' }
    ],
    blockItemsCol: 1,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_increase_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_increase_des',
        img: SlideItem_sli_increase_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_optimize_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.variantDisplay.item_sli_optimize_des',
        img: SlideItem_sli_optimize_des
      }
    ]
  },
  {
    name: 'visualMerchandising',
    url: URL['AddOn_Merchandising'],
    title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.title',
    description: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.description',
    blockItems: [
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_pin' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_boost' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_demote' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_hide' },
      { label: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_filter' }
    ],
    blockItemsCol: 3,
    slides: [
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_pin_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_pin_des',
        img: SlideItem_sli_pin_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_boost_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_boost_des',
        img: SlideItem_sli_boost_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_demote_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_demote_des',
        img: SlideItem_sli_demote_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_hide_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_hide_des',
        img: SlideItem_sli_hide_des
      },
      {
        title: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_filter_title',
        des: 'AdminHTML.SubscriptionV3.ReviewAddonV2.visualMerchandising.item_sli_filter_des',
        img: SlideItem_sli_filter_des
      }
    ]
  }
];

export const DISCOUNT_ERRORS = {
  discount_expired: 'AdminHTML.SubscriptionV3.DiscountCodeError.discountCodeExpired',
  invalid_discount: 'AdminHTML.SubscriptionV3.DiscountCodeError.invalidDiscount',
  not_eligible_discount: 'AdminHTML.SubscriptionV3.DiscountCodeError.notEligible',
  only_apply_addon: 'AdminHTML.SubscriptionV3.DiscountCodeError.onlyApplyAddon',
  not_apply_addon: 'AdminHTML.SubscriptionV3.DiscountCodeError.notApplyAddon'
};

export const FEATURE_COMPARISON = [
  'search',
  'visualMerchandising',
  'recommendation',
  'analytics',
  'advancedProductFilter',
  'themeIntegration',
  'sync',
  'support',
  'compliance'
];

// DATA TABLE OF LIST FEATURE PACKAGE COMPARISON
// Value is addon price with package
//            if value = 0 => auto applied
//            if value = -1 => feature will coming soon
export const DATA_BY_FEATURE = {
  search: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent01',
      subtext: [
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex01',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex02',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex03',
        'AdminHTML.SubscriptionV3.PackageComparison.searchContent01_Tex04'
      ],
      value: [39, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent09',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent10',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent11',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent12',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent13',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent14',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent15',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.searchContent16',
      subtext: [],
      value: [-1, -1, -1]
    }
  ],
  visualMerchandising: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent01',
      subtext: [],
      value: [19, 19, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent02',
      subtext: [],
      value: [19, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent03',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.visualMerchandisingContent04',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    }
  ],
  recommendation: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01',
      subtext: [
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text01',
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text02',
        'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent01_Text03'
      ],
      value: [39, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent062',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.recommendationContent07',
      subtext: [],
      value: [0, 0, 0],
      isRising: true
    }
  ],
  analytics: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent01',
      subtext: [],
      value: [19, 0, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent02',
      subtext: [],
      value: [29, 29, 0],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent03',
      subtext: [],
      value: [49, 49, 49],
      isRising: true
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.analyticsContent09',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  advancedProductFilter: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent03',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent04',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent05',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent06',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent07',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent08',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent09',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent10',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.apfContent11',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  themeIntegration: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.themeIntegrationContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  sync: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.syncContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ],
  support: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.supportContent01',
      contentPlus: 'AdminHTML.SubscriptionV3.PackageComparison.supportPlusContent',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.supportContent02',
      contentPlus: 'AdminHTML.SubscriptionV3.PackageComparison.supportPlusContent',
      subtext: [],
      value: [
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus',
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus',
        'AdminHTML.SubscriptionV3.PackageComparison.supportShopifyPlus'
      ]
    }
  ],
  compliance: [
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent01',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent02',
      subtext: [],
      value: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV3.PackageComparison.complianceContent03',
      subtext: [],
      value: [0, 0, 0]
    }
  ]
};

export const SUBSCRIPTION_STATE = {
  LOCKED: 'locked',
  TRIAL: 'trial',
  NOT_TRIAL: 'not-trial',
  UNLOCK: 'unlock',
  EXPIRED: 'expired'
};
